import { render, staticRenderFns } from "./AdvisorClientMenu.vue?vue&type=template&id=3f01394f&scoped=true"
import script from "./AdvisorClientMenu.vue?vue&type=script&lang=js"
export * from "./AdvisorClientMenu.vue?vue&type=script&lang=js"
import style0 from "./AdvisorClientMenu.vue?vue&type=style&index=0&id=3f01394f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f01394f",
  null
  
)

export default component.exports